/**
 * Navbar — nav-group configuration.
 *
 * Locked story arc (after the Feb 2026 IA dedupe):
 *
 *   1. Intelligence  — Platform overview · Knowledge Graph (Atlas embedded)
 *                       · Opportunities · Capital · Markets · AI Tools · GraphQL
 *   2. Network       — Action surfaces: marketplace, hubs, proof, passports
 *   3. Solutions     — Single page · 5 audience tabs (investors, corporates,
 *                       governments, fintech, landowners)
 *   4. About         — Foundation (People + Community absorbed) · Academy
 *                       · About · Contact
 *
 * Rule: 4 groups in the bar, 6-8 items per group, no overlap.
 *
 * Routes that NO LONGER appear in the nav (redirected to canonical destinations):
 *   /atlas       → /intelligence/explore?view=atlas
 *   /methodology → /intelligence?view=methodology
 *   /credits     → /dpp?view=credits
 *   /asset-exchange → /marketplace?view=assets
 *   /people      → /foundation?view=people
 *   /community   → /foundation?view=community
 *   /for/<slug>  → /solutions?audience=<slug>
 */
export function buildNavGroups(t) {
  return [
    {
      id: "intelligence", label: t("nav.intelligence", { defaultValue: "Intelligence" }),
      items: [
        ["/intelligence",                "Intelligence Platform",  "Overview · methodology · how scores are calculated"],
        ["/intelligence/explore",        "Knowledge Graph",        "Graph + Atlas view of partners · programs · assets · people"],
        ["/intelligence/opportunities",  "Opportunities",          "Pipeline of community-anchored plays"],
        ["/intelligence/capital",        "Capital Ecosystem",      "Funds · CSR · DFIs · family offices"],
        ["/intelligence/markets",        "Markets",                "Prices · indexes · forecasts"],
        ["/ai-tools",                    "AI Tools",               "Waste-to-Resource · Hub Builder · Digital Twin · Calculators"],
        ["/intelligence/graphql",        "GraphQL API",            "Read-only programmatic access · live schema docs"],
      ],
    },
    {
      id: "network", label: t("nav.network", { defaultValue: "Network" }),
      items: [
        ["/network",              "The Circularity Network™", "One Network · two products · how it all connects"],
        ["/network?view=station", "↳  Station OS",            "Digital infrastructure · EV charging + edge compute"],
        ["/network?view=hub",     "↳  Hub OS",                "Resource infrastructure · recycling · biochar"],
        ["/marketplace",          "Marketplace",              "Have / need + asset exchange · matched across the network"],
        ["/hubs",                 "Hub Library",              "Nine deployable hub archetypes"],
        ["/network-proof",        "Network Proof",            "Real partnerships · real status tags"],
        ["/dpp",                  "Verify · Passports + Credits", "Digital passports + verified circular outcomes"],
      ],
    },
    {
      id: "solutions", label: t("nav.solutions", { defaultValue: "Solutions" }),
      items: [
        ["/solutions",                       "Solutions",              "Five audiences · one operating system"],
        ["/solutions?audience=investors",    "↳  For Investors",       "Recurring cash flows from infrastructure"],
        ["/solutions?audience=corporates",   "↳  For Corporates",      "Anchor a hub · hit EPR targets"],
        ["/solutions?audience=governments",  "↳  For Governments",     "Diversion · jobs · EPR"],
        ["/solutions?audience=fintech",      "↳  For Fintech & Banks", "Finance the real economy of materials"],
        ["/solutions?audience=landowners",   "↳  For Landowners",      "Turn idle land into circular yield"],
      ],
    },
    {
      id: "about", label: t("nav.about", { defaultValue: "About" }),
      items: [
        ["/about",       "About Circularity",  "Not a waste company. An infrastructure network."],
        ["/foundation",  t("nav.foundation", { defaultValue: "Foundation" }), "People-first share of circular growth (People + Community)"],
        ["/academy",     t("nav.academy", { defaultValue: "Academy" }),       "Courses for builders & operators"],
        ["/contact",     "Contact",            "Join the network"],
      ],
    },
  ];
}
